import { ArrowRight } from "lucide-react";

import upgradeWithNettle from "../../assets/images/upgradeWithNettle.webp";
import { LINKS } from "../../constants/links";
import { cn } from "../../utils/styling";

export function NettlePurchaseCTACard() {
  return (
    // TODO: Make smarter (on iOS show iOS only, on Android show Google Play only. On desktop show QR of both)
    <div className="w-full h-[300px]  bg-red-800 rounded-2xl relative overflow-hidden">
      <img
        src={upgradeWithNettle}
        alt="Upgrade with Nettle"
        className="absolute inset-0 w-full h-full object-cover "
      />
      <div className="relative z-10 h-full flex flex-col justify-between p-4">
        <div className="text-2xl text-white">
          Upgrade your experience with Nettle™
        </div>
        <div className="flex flex-col gap-4 w-full">
          <CTALine variant="brand" href="/purchase?stage=2&product=nettle">
            Try Nettle™
          </CTALine>
          <CTALine variant="white" href={LINKS.NETTLE_PAGE}>
            Learn More
          </CTALine>
        </div>
      </div>
    </div>
  );
}

function CTALine({
  href,
  children,
  variant,
}: {
  href: string;
  children: React.ReactNode;
  variant: "brand" | "white";
}) {
  return (
    <a
      className={cn(
        "w-full rounded-full py-3 px-4 flex flex-row justify-between items-center shadow-sm",
        variant === "brand"
          ? "bg-brand-primary hover:bg-brand-primary-darker"
          : "bg-white hover:bg-gray-300",
      )}
      href={href}
      target="_blank"
      rel="noopener noreferrer" // Security: add rel="noopener noreferrer" when using target="_blank" to prevent tabnabbing
    >
      <p
        className={cn(
          "text-sm",
          variant === "brand" ? "text-white" : "text-black",
        )}
      >
        {children}
      </p>
      <ArrowRight
        className={cn(
          "w-4 h-4",
          variant === "brand" ? "text-white" : "text-black",
        )}
      />
    </a>
  );
}
